import { TextField } from '@mui/material';
import { GridRenderCellParams, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { formatNumber, NumberFormatPreset } from '@procureai/ui-mui';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextFieldCellType } from '../../DataGridCustom.types';
import { DefaultDataEditGridConfig } from '~/components/DataGridCustom';
import { defaultTextFieldProps } from '~/components/DataGridCustom/common/defaults';

interface TextFieldCellProps<R extends GridValidRowModel> extends GridRenderCellParams<R>, DefaultDataEditGridConfig {
  preset?: NumberFormatPreset;
  type?: TextFieldCellType;
  disabled?: boolean;
}

export const TextFieldCell = <R extends GridValidRowModel & { id: GridRowId } = { id: GridRowId }>({
  colDef,
  getRowIndex,
  pathPrefix,
  preset,
  row,
  type = TextFieldCellType.TEXT,
  languageNamespace,
  keyPrefix,
  textFieldProps,
  disabled,
}: TextFieldCellProps<R>) => {
  const { t: tPrefix } = useTranslation(languageNamespace, { keyPrefix });
  const p = [...(pathPrefix ?? []), getRowIndex?.(row.id), colDef.field];

  return (
    <Controller
      name={p.join('.')}
      defaultValue=""
      disabled={disabled}
      render={({ field, fieldState }) => {
        return (
          <TextField
            {...field}
            label={tPrefix(colDef.field)}
            type={type}
            error={!!fieldState.error}
            value={preset ? formatNumber(preset, Number(field.value)) : field.value}
            {...defaultTextFieldProps}
            {...textFieldProps}
          />
        );
      }}
    />
  );
};
